<template>
	<div>
		<sBox title="Grade ">
			<div slot="tools">
				<div class="box-excel-export">
					<aBtn
						action="private-save-cargos2"
						@click="$refs.modalExcel.open()"
						text="Importar Excel"
						icon="plus"
						size="sm"
						type="info"
						class="btn-export"
					/>

					<aBtn
						@click="handleConvertTableToXLS()"
						text="Exportar Excel"
						icon="minus"
						size="sm"
						type="info"
						class="btn-import"
					/>
				</div>
			</div>
			<div slot="body">
				<br />
				<sBox title="Filtrar Cargos">
					<div class="row" slot="body">
						<div class="col-sm-3">
							<span>id</span>
							<input
								v-model="filter.id"
								@input="fxFilter('id', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="ID"
							/>
						</div>
						<div class="col-md-3">
							<span>Cargo</span>
							<input
								v-model="filter.nome_cargo"
								@input="
									fxFilter('nome_cargo', $event.target.value)
								"
								type="text"
								class="form-control"
								placeholder="CARGO"
							/>
						</div>
						<!-- <div class="col-sm-3">
							<span>CPF</span>
							<input
								v-mask='"###.###.###-##"'
                placeholder="999.999.999-99"
								v-model='filter.CPF'
								@input='fxFilter("CPF", $event.target.value)'
								type="text"
								class="form-control">
						</div> -->
						<div class="col-sm-3">
							<span>CBO</span>
							<input
								v-model="filter.CBO"
								@input="fxFilter('CBO', $event.target.value)"
								type="text"
								class="form-control"
								placeholder="CBO"
							/>
						</div>
					</div>
				</sBox>

				<br />
				<!-- action='private-save-cargos2'	 -->
				<!-- @click='this.handleConvertTableToXLS()' -->
				<div class="box-excel-export">
					<aBtn
						action="private-save-cargos"
						@click="$refs.modal.open()"
						text="Cargos"
						icon="plus"
						size="sm"
						type="success"
					/>
				</div>

				<br />
				<sTable
					ref="tab"
					actionRead="private-read-cargos"
					actionDelete="private-delete-cargos"
					:labels="labels"
					:actions="['delete', 'edit']"
					:functions="functions"
					@edit="(data) => $refs.modal.open(data)"
				/>
			</div>
		</sBox>
		<modal ref="modal" @update="$refs.tab.updateTable()" />
		<modal2 ref="modalExcel" id="modal2" />
	</div>
</template>
<script>
	// import WBS from 'js/http'
	import sTable from 'table';
	import sBox from 'box';
	import aBtn from 'btn';
	import modal from './modal.vue';
	import modal2 from './modal2.vue';
	import pad from 'js/pad';
	import { mask } from 'vue-the-mask';

	var XLSX = require('xlsx');

	export default {
		name: 'AppCadastroCargosdeCargos',
		components: { sTable, sBox, modal, aBtn, modal2 },
		data() {
			return {
				labels: [
					{ data: 'id', label: 'ID' },
					{ data: 'nome_cargo', label: 'Cargo' },
					{ data: 'CBO', label: 'CBO' },
				],

				filter: {
					id: '',
					nome_cargo: '',
					CBO: '',
				},
				// functions: [
				// 	{ cod: 'cod', fx: (val)=>{return pad(val, 5)} }
				// ]
			};
		},
		methods: {
			fxFilter(col, val) {
				let f = [];

				if (this.filter.id != '')
					f.push(`id like '%${this.filter.id}%'`);

				if (this.filter.nome_cargo != '')
					f.push(`nome_cargo like '%${this.filter.nome_cargo}%'`);

				if (this.filter.CBO != '')
					f.push(`CBO like '%${this.filter.CBO}%'`);

				f = f.join(' and ');

				// console.log(f)

				console.log(f);

				if (f != '') this.$refs.tab.setFilter(f);
				else this.$refs.tab.setFilter('');
				this.$refs.tab.updateTable();
			},
			handleConvertTableToXLS() {
				const mainTable = document.querySelector('.table');
				console.log(mainTable);

				const jsonExcelData = XLSX.utils.table_to_book(mainTable);

				console.log(jsonExcelData);

				const nameOfFile = 'Dados dos Cargos .xlsx';

				XLSX.writeFile(jsonExcelData, nameOfFile);
			},
		},
		mounted() {
			this.$emit('setHeader', ['Gerenciamento De Cargos ', '']);
		},
	};
</script>

<style>
	.box-excel-export {
		width: 100%;
		display: flex;
		justify-content: end;
	}

	.btn-import {
		margin-left: 15px;
	}

	.btn-export {
		filter: saturate(1.5);
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/cargos/index.vue